// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import axios from 'axios'
import Axios from './api/user.js'

import ElementUI from 'element-ui'
import CryptoJs from 'crypto-js';  //引用AES源码js
// 头部
import Head from './components/Head'
// 底部
import Footer from './components/Footer'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/bootstrap.min.css'
import '../static/animate.min.css'
import '../static/main.css'
import '../static/swiper.min.css'
// import $ from 'jquery'
import echarts from 'echarts'
import 'echarts/map/js/china.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'babel-polyfill'
// 生成pdf
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
// 导出excel
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
// 打印
import Print from 'vue-print-nb'
// import print from 'print-js'

Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.component('Head', Head)
Vue.component('Footer', Footer)
Vue.prototype.$http = Axios
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI)
Vue.use(Print)

// Vue.prototype.$Swiper = Swiper
/* eslint-disable no-new */

Vue.prototype.exportExcel = function (element, title) {
  /* 从表生成工作簿对象 */
  var xlsxParam = { raw: true } // 导出的内容只做解析，不进行格式转换
  var table = document.querySelector(element)
  var fix = document.querySelector('.el-table__fixed')
  var fix2 = document.querySelector('.el-table__fixed-right')
  let wb
  if (fix && table.contains(fix)) {
    wb = XLSX.utils.table_to_book(table.removeChild(fix), xlsxParam)
    table.appendChild(fix)
  } else if (fix2 && table.contains(fix2)) {
    wb = XLSX.utils.table_to_book(table.removeChild(fix2), xlsxParam)
    table.appendChild(fix2)
  } else {
    wb = XLSX.utils.table_to_book(table, xlsxParam)
  }
  /* 获取二进制字符串作为输出 */
  var wbout = XLSX.write(wb, {
    bookType: 'xlsx',
    bookSST: true,
    type: 'array'
  })
  try {
    FileSaver.saveAs(
      new Blob([wbout], { type: 'application/octet-stream' }),
      title + '.xlsx'
    )
  } catch (e) {
    if (typeof console !== 'undefined') console.log(e, wbout)
  }
  return wbout
}
Vue.prototype.getImg = function (element, name) {
  html2Canvas(document.querySelector(element), {
    useCORS: true, // 是否尝试使用CORS从服务器加载图像
    async: false, // 是否异步解析和呈现元素
    // 以下字段必填
    // background: "#ffffff", // 一定要添加背景颜色，否则出来的图片，背景全部都是透明的
    dpi: 300, // 处理模糊问题
    onrendered: function (canvas) {
      let url = canvas.toDataURL()
    }
  }).then(function (canvas) {
    let pageData = canvas.toDataURL('image/jpeg', 1.0)

    var arr = pageData.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    var myBlob = new Blob([u8arr], { type: mime })
    var myUrl = URL.createObjectURL(myBlob)
    var a = document.createElement('a')
    a.setAttribute('href', myUrl)
    a.setAttribute('download', name)
    a.setAttribute('target', '_blank')
    let clickEvent = document.createEvent('MouseEvents')
    clickEvent.initEvent('click', true, true)
    a.dispatchEvent(clickEvent)
  })
}

Vue.prototype.getPdf = function (title, element) {
  html2Canvas(document.querySelector(element), {
    useCORS: true, // 是否尝试使用CORS从服务器加载图像
    async: false, // 是否异步解析和呈现元素
    // 以下字段必填
    background: '#ffffff', // 一定要添加背景颜色，否则出来的图片，背景全部都是透明的
    dpi: 300, // 处理模糊问题
    onrendered: function (canvas) {
      // https://developer.mozilla.org/zh-CN/docs/Web/API/HTMLCanvasElement/toDataURL
      // let url = canvas.toDataURL('image/png', 1.0)
      let url = canvas.toDataURL()
    }
  }).then(function (canvas) {
    let contentWidth = canvas.width
    let contentHeight = canvas.height
    let pageHeight = (contentWidth / 592.28) * 841.89
    let leftHeight = contentHeight
    let position = 0
    let imgWidth = 595.28
    let imgHeight = (592.28 / contentWidth) * contentHeight
    let pageData = canvas.toDataURL('image/jpeg', 1.0)
    // let PDF = new JsPDF('', 'pt', 'a4')
    let pdfHeight = imgHeight + 20
    let PDF = new JsPDF('p', 'pt', [imgWidth, pdfHeight])
    // if (leftHeight < pageHeight) {
    PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
    // } else {
    //   while (leftHeight > 0) {
    //     PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
    //     leftHeight -= pageHeight
    //     position -= 841.89
    //     if (leftHeight > 0) {
    //       PDF.addPage()
    //     }
    //   }
    // }
    PDF.save(title + '.pdf')
  })
}

Vue.prototype.dateFormat = function (t, str) {
  if (t instanceof Date && isNaN(t.getTime())) return ''
  let obj = {
    yyyy: t.getFullYear(),
    yy: t
      .getFullYear()
      .toString()
      .slice(-2),
    MM: (t.getMonth() + 1).toString().padStart(2, '0'),
    M: t.getMonth() + 1,
    dd: t
      .getDate()
      .toString()
      .padStart(2, '0'),
    d: t.getDate(),
    HH: t
      .getHours()
      .toString()
      .padStart(2, '0'),
    H: t.getHours(),
    hh: (t.getHours() % 12).toString().padStart(2, '0'),
    h: t.getHours() % 12,
    mm: t
      .getMinutes()
      .toString()
      .padStart(2, '0'),
    m: t.getMinutes(),
    ss: t
      .getSeconds()
      .toString()
      .padStart(2, '0'),
    s: t.getSeconds(),
    w: ['日', '一', '二', '三', '四', '五', '六'][t.getDay()]
  }
  return str.replace(/[a-z]+/gi, $1 => {
    return obj[$1]
  })
}

Vue.filter('getDownFileName', function (url) {
  if (typeof url !== 'string') {
    throw '不是字符串'
  }
  url = decodeURIComponent(url)
  var splitPart = url.lastIndexOf('/')
  var pointPart = url.lastIndexOf('.')
  // url.substr(splitPart + 1, url.length - 1 - pointPart)

  return url.substr(splitPart + 1)
})

let vueThis = new Vue({
  el: '#app',
  router,
  data: function () {
    return {
      series_id: 0,
      name_list: 0,
      isBack: false
    }
  },
  components: { App },
  template: '<App/>'
})

export default vueThis



// WEBPACK FOOTER //
// ./src/main.js